import React from "react";
import { authUser } from "../../utils/Functions/functions";
import { Link, useLocation } from "react-router-dom";
import * as Icons from "../../assets/Icons";
import "./Header.scss";
import { useEffect } from "react";
function Header() {
  const [activePage, setActivePage] = React.useState("");
  const [menuOpen, setMenuOpen] = React.useState(false);
  const location = useLocation();
  const form = location.pathname === "/form" || location.pathname === "/";
  const jwtUserAuth = () => authUser(localStorage.getItem("JWT"));
  const signInLabel = jwtUserAuth() ? "My skyu" : "My skyu";
  const signInPath = jwtUserAuth() ? "dashboard" : "signin";
  const iconColor = form ? "White" : "Orange";
  useEffect(() => {
    if (
      (activePage !== "My skyu" && window.location.pathname === "/dashboard") ||
      (activePage !== "My skyu" && window.location.pathname === "/admin")
    ) {
      setActivePage("My skyu");
    }
  }, [activePage]);

  const linksCommon = [
    {
      label: "Contact",
      id: "contact",
      icon: Icons[`Contact${iconColor}`],
      mobileIcon: Icons.ContactOrange,
      path: "https://www.skyu.hu/contact",
      outside: true,
    },
    {
      label: signInLabel,
      id: "signin",
      icon: Icons[`Signin${iconColor}`],
      mobileIcon: Icons.SigninOrange,
      path: signInPath,
    },
    {
      label: "Tracking",
      id: "tracking",
      icon: Icons[`Tracking${iconColor}`],
      mobileIcon: Icons.TrackingOrange,
      path: "track",
    },
  ];

  const linksForm = linksCommon;
  const linksUser = [
    {
      label: "Services",
      id: "services",
      icon: Icons.TrackingOrange,
      mobileIcon: Icons.TrackingOrange,
      path: "https://www.skyu.hu/services",
      outside: true,
    },
    {
      label: "About us",
      id: "services",
      icon: Icons.AboutUsOrange,
      mobileIcon: Icons.AboutUsOrange,
      path: "https://www.skyu.hu/about-us",
      outside: true,
    },
    {
      label: "Career",
      id: "career",
      icon: Icons.CareerOrange,
      mobileIcon: Icons.CareerOrange,
      path: "https://www.skyu.hu/carreer",
      outside: true,
    },
    {
      label: "News",
      id: "new",
      icon: Icons.NewsOrange,
      mobileIcon: Icons.NewsOrange,
      path: "https://www.skyu.hu/news",
      outside: true,
    },
    ...linksCommon,
  ];

  const selectNavItems = form ? linksForm : linksUser;

  const linkOnClickHandler = (link) => {
    setActivePage(link.label);
    setMenuOpen(false);
  };

  const linkMapper = (link, i) => {
    const liClassName = `HeaderLinkItem ${
      activePage === link.label && "Active"
    } ${!form && "Black"}`;
    const imgSrc = window.innerWidth < 600 ? link.mobileIcon : link.icon;
    const icon = link.icon && (
      <span className="MarginSides">
        <img src={imgSrc} alt={link.id} />
      </span>
    );
    return (
      !(link.label === "Register" && jwtUserAuth()) && (
        <div className="LinkItemContainer">
          {link.outside === true ? (
            <a key={i} href={link.path} rel="noopener noreferrer">
              <li
                key={i}
                className={liClassName}
                onClick={() => linkOnClickHandler(link)}
              >
                {icon}
                {link.label}
              </li>
            </a>
          ) : (
            <Link key={i} to={`/${link.path}`}>
              <li
                key={i}
                className={liClassName}
                onClick={() => linkOnClickHandler(link)}
              >
                {icon}
                {link.label}
              </li>
            </Link>
          )}
        </div>
      )
    );
  };

  return (
    <header className={`Header ${!form && "GreyBorder"}`}>
      <a href="https://www.skyu.hu/">
        <img
          src={form ? Icons.LogoWhite : Icons.LogoColor}
          className="HeaderLogo"
          alt="logo"
        />
      </a>
      <div className={`HeaderLink ${menuOpen && "Open"}`}>
        {selectNavItems.map(linkMapper)}
        <div className="LinkItemContainer Hidden">
          <span>
            <li className="HeaderLinkItem">HU | EN</li>
          </span>
        </div>
      </div>
      <label
        className={`HamburgerMenu ${!form && "Black"}`}
        onClick={() => setMenuOpen(!menuOpen)}
      >
        {menuOpen ? "x" : "☰"}
      </label>
    </header>
  );
}

export default Header;
